import request from "@/global/request/request";
import API from "@/global/request/api";

const skillService = {
  skillKnowledge(id) {
    return request.get(API.skillSkillIdKnowledge(id));
  },
  taskList(params = {}) {
    return request.get(API.skillTask, params);
  },
  taskShow(id) {
    return request.get(API.skillTaskItem(id));
  },
  topicList(params = {}) {
    return request.get(API.skillTopic, params);
  },
  topicShow(id) {
    return request.get(API.skillTopicItem(id));
  },
  topicAdd(params = {}) {
    return request.post(API.skillTopic, params);
  },
  topicEdit(id, params = {}) {
    return request.put(API.skillTopicItem(id), params);
  },
  proofreadTasks(params = {}) {
    return request.get(API.skillProofreadTasks, params);
  },
  proofreadTasksMy(params = {}) {
    return request.get(API.skillProofreadTasksMy, params);
  },
  proofreadTaskAssign(id) {
    return request.put(API.skillProofreadTaskAssign(id));
  },
  proofreadTaskPass(id) {
    return request.put(API.skillProofreadTaskPass(id));
  },
  proofreadQuestionNext(id) {
    return request.get(API.skillProofreadQuestionNext(id));
  },
  proofreadQuestionStatus(id, params = {}) {
    return request.get(API.skillProofreadQuestionStatus(id), params);
  },
  proofreadQuestionVerify(id, question_id, params = {}) {
    return request.put(
      API.skillProofreadQuestionVerify(id, question_id),
      params
    );
  },
  proofreadQuestionItem(id, question_id) {
    return request.get(API.skillProofreadQuestionItem(id, question_id));
  },
  proofreadTaskItem(id) {
    return request.get(API.skillProofreadTaskItem(id));
  },
  //question-service1.4
  skillQuestionReviewTaskTypeQuestions(type, params) {
    return request.get(API.skillQuestionReviewTaskTypeQuestions(type), params);
  },
  skillQuestionReviewTaskTypeQuestionPass(type, id, params) {
    return request.put(
      API.skillQuestionReviewTaskTypeQuestionPass(type, id),
      params
    );
  },
  skillQuestionReviewTaskTypeQuestionReject(type, id, params = {}) {
    return request.put(
      API.skillQuestionReviewTaskTypeQuestionReject(type, id),
      params
    );
  },
  skillQuestionReviewTaskQuestionDetail(id) {
    return request.get(API.skillQuestionReviewTaskQuestionId(id));
  },
  skillQuestionReviewTaskTypeQuestionsMy(type, params) {
    return request.get(
      API.skillQuestionReviewTaskTypeQuestionsMy(type),
      params
    );
  },
  skillQuestionReviewTaskTypeStatistics(type) {
    return request.get(API.skillQuestionReviewTaskTypeStatistics(type));
  },
  //题目抽检
  skillSpotCheckList(params) {
    return request.get(API.skillSpotCheckTask, params);
  },
  skillSpotCheckQuestion(id, params) {
    return request.get(API.skillSpotCheckQuestion(id), params);
  },
  skillSpotCheck(id, taskId, params) {
    return request.put(API.skillSpotCheck(id, taskId), params);
  },
  skillBuildTasksList(params) {
    return request.get(API.skillBuildTasks, params);
  },
  getSkillKnowledgeInfo(id) {
    return request.get(API.skillKnowledgeInfo(id));
  },
  chatGptInfo(params) {
    return request.post(API.chatGpt, params);
  },
  getGptDialog() {
    return request.post(API.chatGptDialog);
  },
  chatGptKiMiFiles(params) {
    return request.post(API.chatGptKiMiFiles, params);
  },
  saveSkillKnowledgeContent(id, knowledgePointId, params) {
    return request.put(API.skillKnowledgeContent(id, knowledgePointId), params);
  },
  getSkillKnowledgeContent(id, knowledgePointId) {
    return request.get(API.skillKnowledgeContent(id, knowledgePointId));
  },
  submitSkillKnowledgeVerify(id, knowledgePointId) {
    return request.put(API.skillKnowledgeVerify(id, knowledgePointId));
  },
  // 批量上传
  teacherList(query) {
    return request.get(API.teacherList, query);
  }
};

export default skillService;
